import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Main from "./layout/Main";
import { useAuthContext } from "../context/AuthContext";
import Loader from "./Loader";

const getCurrentRole = () => {
  const explicitRole = localStorage.getItem("authRole");
  if (explicitRole) return explicitRole;
  try {
    const profile = JSON.parse(localStorage.getItem("userProfile") || "{}");
    const userType = profile?.userType || profile?.user_type;
    if (userType === "Super_Admin") return "admin";
    if (userType === "HotelPartner") return "hotel";
    if (userType === "Agent") return "agent";
    if (userType === "Airline") return "airline";
  } catch (_err) {
    return "admin";
  }
  return "admin";
};

const ROLE_HOME = {
  admin: "/dashboard",
  hotel: "/hotel-management",
  agent: "/agent-dashboard",
  airline: "/airline-management",
};

const PrivateRoute = ({ children, allowedRoles = ["admin", "hotel", "agent", "airline"] }) => {
  const { isLoggedIn, isInitializing } = useAuthContext();
  const location = useLocation();
  const role = getCurrentRole();
  const token =
    localStorage.getItem("token") ||
    (() => {
      try {
        const data = JSON.parse(localStorage.getItem("loginData") || "{}");
        return (
          data?.token ||
          data?.accessToken ||
          data?.jwt ||
          data?.data?.token ||
          data?.data?.accessToken ||
          data?.Details?.token ||
          null
        );
      } catch (_err) {
        return null;
      }
    })();
  const hasSessionFallback =
    !!localStorage.getItem("loginData") && !!localStorage.getItem("userProfile");
  const loginRedirect =
    allowedRoles.length === 1 && allowedRoles[0] === "admin"
      ? "/admin/login"
      : "/login";

  // Show loader while checking authentication
  if (isInitializing) {
    return <Loader />;
  }

  // If no token and not logged in, redirect to login
  // some backends may not yet return a token, so we also trust isLoggedIn state
  if (!token && !isLoggedIn && !hasSessionFallback) {
    return <Navigate to={loginRedirect} state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={ROLE_HOME[role] || loginRedirect} replace />;
  }

  return <Main>{children}</Main>;
};

export default PrivateRoute;
